/* eslint-disable angular/controller-name */
/* eslint-disable angular/controller-as */

(function iife() {
	"use strict";

	angular.module("dx.webapp.forgotPassword").
		controller("ForgotPasswordPasswordChangedRouteController", ForgotPasswordPasswordChangedRouteController);

	function ForgotPasswordPasswordChangedRouteController(
		$scope,
		$window,

		DX_URLS
	) {
		$scope.Urls = DX_URLS;
		$scope.isSetPassword = $window.location.href.indexOf("set-password") > -1;
	}
}());
